import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import FullscreenToggle from '../components/FullscreenToggle';
import ClaimRow from './ClaimRow';

const Claims = ({ patientId, onExpand, onContract, onDataExists }) => {
	const [{ data: claims, /* error */ }] = useAxios(`/patients/${patientId}/claims`);

	useEffect(() => {
		if (Array.isArray(claims) && claims.length > 0) {
			onDataExists();
		}
	}, [claims]);

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			{Array.isArray(claims) && claims.length > 0 && (
				<table className="table table-striped">
					<thead>
						<tr>
							<th>Type</th>
							<th>Organization<br />Place of Service</th>
							<th>Procedure</th>
							<th>Started</th>
							<th>Ended</th>
							<th>Source</th>
							<th>Updated On</th>
						</tr>
					</thead>
					<tbody>
						{claims.map((claim) => (
							<ClaimRow key={`${claim.id}`} claim={claim} />
						))}
					</tbody>
				</table>
			)}
		</div>
	);
};

Claims.propTypes = {
	patientId: PropTypes.number,
	onExpand: PropTypes.func,
	onContract: PropTypes.func,
	onDataExists: PropTypes.func,
};

export default Claims;
